/**
 * PRX-143 — the PHOX Entry intake queue's closed lists, mirrored from the
 * server's single source of truth `backend-v2/src/phox-entry/phox-entry.constants.ts`
 * (`phoxEntry.drift.spec.ts` reads it as text — change both together).
 */
export const PHOX_ENTRY_STATUSES = ['waiting', 'entered', 'dismissed'] as const;
export type PhoxEntryStatus = (typeof PHOX_ENTRY_STATUSES)[number];

export const PHOX_ENTRY_REQUEST_TYPES = ['refill', 'new_rx', 'transfer'] as const;
export type PhoxEntryRequestType = (typeof PHOX_ENTRY_REQUEST_TYPES)[number];

export const PHOX_ENTRY_FULFILMENTS = ['delivery', 'pickup'] as const;
export type PhoxEntryFulfilment = (typeof PHOX_ENTRY_FULFILMENTS)[number];

export const PHOX_ENTRY_STATUS_LABELS: Record<PhoxEntryStatus, string> = {
  waiting: 'Waiting',
  entered: 'Entered',
  dismissed: 'Dismissed',
};

export const PHOX_ENTRY_REQUEST_TYPE_LABELS: Record<PhoxEntryRequestType, string> = {
  refill: 'Refill',
  new_rx: 'New Rx',
  transfer: 'Transfer',
};

export const PHOX_ENTRY_FULFILMENT_LABELS: Record<PhoxEntryFulfilment, string> = {
  delivery: 'Delivery',
  pickup: 'Pickup',
};

/** The queue page's address. */
export const PHOX_ENTRY_QUEUE_PATH = '/order-fulfillment/phox-entry-queue';

/**
 * The PRX-54 visibility key behind PHOX Entry (the sidebar entry). Also gates
 * the Communication Center's Push to PHOX Entry action and its chip, so a
 * pharmacy that hides the queue is not offered a way into it.
 */
export const PHOX_ENTRY_VISIBILITY_KEY = 'sidebar.item.phox_entry_queue';
